import { UNCLASSED_CLASS_ID, classIdForLabel } from './allocationClasses.js'

// One adapter from solver output to the authored plan contract. Both the guided
// UI and Julio use this function; neither writes historical engine fields.
//
// Class labels ARE the census codes, so a label maps straight to its class id
// with no plan-side registry to reconcile: the caller writes the same labels
// onto the census rows in the same transaction.
export function buildNewCompScenarioApplication(plan, design, _groupAssignments = {}, cashBalance = null) {
  const designGroups = Array.isArray(design?.groups) ? design.groups : []
  const groupIdForLabel = (label) => {
    const trimmed = String(label ?? '').trim()
    return trimmed ? classIdForLabel(trimmed) : UNCLASSED_CLASS_ID
  }
  const labelFor = (label) => String(label ?? '').trim()
  const currentConditions = plan?.employerContributions?.profitSharing?.conditions
    || { minHours: 0, lastDayRequired: false, combinator: 'and', waivers: null }
  const patch = {
    employerContributions: {
      profitSharing: {
        mode: 'standard',
        enabled: true,
        funding: { mode: 'rate' },
        formula: {
          type: 'new_comparability',
          groupMode: 'grouped',
          groups: designGroups.map((group) => ({
            groupId: groupIdForLabel(group.label),
            groupLabel: labelFor(group.label),
            formula: group.formula?.method === 'fill_415c'
              ? { method: 'fill_415c' }
              : {
                  method: group.formula?.method === 'flat' ? 'flat' : 'percent',
                  value: Math.max(0, Number(group.formula?.method === 'flat'
                    ? group.formula?.amount : group.formula?.percent) || 0),
                },
          })),
        },
        conditions: currentConditions,
      },
    },
  }
  if (cashBalance && Array.isArray(cashBalance.creditsByLabel)) {
    patch.cashBalance = {
      mode: 'structured',
      enabled: true,
      credits: cashBalance.creditsByLabel.map((credit) => ({
        groupId: groupIdForLabel(credit.label),
        groupLabel: labelFor(credit.label),
        formula: {
          method: credit.method === 'flatDollar' ? 'flatDollar' : 'percentOfPay',
          value: Math.max(0, Number(credit.value) || 0),
        },
      })),
      interestCredit: {
        type: 'fixed',
        rate: Math.min(6, Math.max(0, Number(cashBalance.interestCreditRatePercent) || 5)),
      },
      eligibility: plan?.cashBalance?.eligibility
        || { enabled: false, minAge: 21, minServiceMonths: 12, minHours: 1000, entryFrequency: 'semiannual' },
    }
  }
  return { patch, groupIdForLabel }
}
